<template>
<div class="badge text-white" :class="variant">
    {{ status }}
</div>
</template>

<script>
import Vue from 'vue'
import {posStatusStr, posVariant} from "../../../constants/PosStatus";

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    computed: {
        status() {
            return posStatusStr.get(this.row.status)
        },
        variant() {
            return 'badge-'+posVariant(this.row.status)
        }
    }
})
</script>

<style>

</style>